import React, { FC } from 'react';

import { Box, Typography, useTheme } from '@mui/material';
import { CourseFixedGlanceItem } from 'src/types/courseFixedGlanceItem';

import ResultPanelEmptyData from '@components/store/data-display/resultPanel/resultPanelEmptyData';
import CourseFixedGlanceSkeleton from '@components/store/product/courseFixedGlance/courseFixedGlanceSkeleton';

type BundleCourseFixedGlanceProps = {
  isLoading: boolean;
  glances: CourseFixedGlanceItem[];
};

const BundleCourseFixedGlance: FC<BundleCourseFixedGlanceProps> = ({ isLoading, glances }) => {
  const theme = useTheme();

  if (isLoading) {
    return <CourseFixedGlanceSkeleton />;
  }

  if (!isLoading && !glances.length) {
    return <ResultPanelEmptyData sx={{ height: { xs: 264, lg: 320 } }} />;
  }

  return (
    <Box display="grid" gridTemplateColumns={{ md: '1fr 1fr', lg: '1fr' }} gap={{ xs: 2, md: '8px 16px', lg: 1.5 }}>
      {glances.map(({ icon, title, subTitle }) => {
        return (
          <Box key={title} display="grid" gridTemplateColumns="24px 1fr" alignItems="start" gap={1}>
            <Box width="24px" height="24px" display="grid" alignItems="center" justifyContent="center">
              {icon}
            </Box>
            <Box>
              <Typography variant="h5" whiteSpace="break-spaces">
                {title}
              </Typography>
              {subTitle ? (
                <Typography variant="body1lanna" color={theme.palette.textV2.secondary}>
                  {subTitle}
                </Typography>
              ) : null}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default BundleCourseFixedGlance;
